require('../filter-editor-modal.component.scss');
require('./ocr-filter-editor.component.scss')

const OCR_LANGUAGES = [
  { label: gettext('Английский'), value: 'eng'},
  { label: gettext('Русский'), value: 'rus'},
  { label: gettext('Казахский'), value: 'kaz'},
  //{ label: gettext('Немецкий'), value: 'deu'},
  //{ label: gettext('Французский'), value: 'fra'},
  //{ label: gettext('Испанский'), value: 'spa'},
  //{ label: gettext('Итальянский'), value: 'ita'},
  //{ label: gettext('Португальский'), value: 'por'},
  //{ label: gettext('Нидерландский'), value: 'nld'},
  //{ label: gettext('Финский'), value: 'fin'},
  //{ label: gettext('Каталонский'), value: 'cat'},
  //{ label: gettext('Индонезийский'), value: 'ind'},
  //{ label: gettext('Шведский'), value: 'swe	'},
  //{ label: gettext('Турецкий'), value: 'tur'},
  //{ label: gettext('Румынский'), value: 'ron'},
  //{ label: gettext('Датский'), value: 'dan'},
  //{ label: gettext('Норвежский'), value: 'nor'},
  //{ label: gettext('Польский'), value: 'pol'},
  //{ label: gettext('Венгерский'), value: 'hun'},
  //{ label: gettext('Эстонский'), value: 'est'},
  //{ label: gettext('Словенский'), value: 'slv'},
  //{ label: gettext('Хорватский'), value: 'hrv'},
  //{ label: gettext('Чешский'), value: 'ces'},
  //{ label: gettext('Словацкий'), value: 'slk'},
  //{ label: gettext('Литовский'), value: 'lit'},
  //{ label: gettext('Латышский'), value: 'lav'},
  //{ label: gettext('Болгарский'), value: 'bul'},
  // Not supported!
  //{ label: gettext('Китайский упрощенный'), value: 'Chinese_Simplified'},
  //{ label: gettext('Китайский традиционный'), value: 'Chinese_Traditional'},
  //{ label: gettext('Арабский'), value: 'Arabic'},
  //{ label: gettext('Корейский'), value: 'Korean'},
  //{ label: gettext('Японский'), value: 'Japanese'}
];

export class ocrFilterEditorController {

  constructor($scope, CurrentModelService) {
    this.$scope = $scope;
    this.CurrentModelService = CurrentModelService;
  }

  $onInit() {

    this.$scope.filter = this.filter.filter;

    this.$scope.languages = OCR_LANGUAGES;

    if (!this.$scope.filter.languages) {
      this.$scope.filter.languages = [OCR_LANGUAGES[0].value];
    } else {

      let languages = '';

      let originLanguages = [];

      if (typeof this.$scope.filter.languages == 'string') {

        languages = this.$scope.filter.languages.split('+');
      } else {
        languages = this.$scope.filter.languages;
      }

      for (let i=0;i<OCR_LANGUAGES.length;i++) {
        if (languages.includes(OCR_LANGUAGES[i].value)) {
          originLanguages.push(OCR_LANGUAGES[i].value);
        }
      }
      if(!originLanguages.length) {
        this.$scope.filter.languages = [OCR_LANGUAGES[0].value];
      } else {
        this.$scope.filter.languages = originLanguages;
      }

    }
  }

  get filterText(){
    return JSON.stringify(this.filter, undefined, 2);
  }
}

export const OcrFilterEditorComponent = {
  bindings: {
    filter    : '<',
    // filter: '=',
  },
  template: require('./ocr-filter-editor.component.html'),
  controller: ocrFilterEditorController,
};



// WEBPACK FOOTER //
// ./src/filter/editor/spec-forms/ocr-filter-editor.component.js